import 'swiper/swiper-bundle.min.css';

import React, { forwardRef, ReactNode, useEffect, useRef } from 'react';
// import Swiper core and required modules
import SwiperCore, { Autoplay, Pagination, Scrollbar, EffectFade } from 'swiper';
import { Swiper as ReactSwiper, SwiperSlide as ReactSwiperSlide } from 'swiper/react';
import { Swiper as SwiperProps, SwiperSlide as SwiperSlideProps } from 'swiper/swiper-react';

export { Swiper as SwiperTypes } from 'swiper';
// install Swiper modules
SwiperCore.use([Scrollbar, Autoplay, Pagination, EffectFade]);

export type Props = {
  children?: string | ReactNode[] | ReactNode;
  activeIndex?: number;
  scrollCenter?: boolean;
} & SwiperProps;

export type SlideProps = {
  children?: string | ReactNode[] | ReactNode;
} & SwiperSlideProps;

export const SwiperSlide = forwardRef(({ children, ...rest }: SlideProps, ref) => {
  return <ReactSwiperSlide {...rest}>{children}</ReactSwiperSlide>;
});

SwiperSlide.displayName = 'SwiperSlide';

export default function Swiper({ children, activeIndex = -1, onSwiper, scrollCenter = true, ...rest }: Props) {
  const swiperRef = useRef(null);
  useEffect(() => {
    if (!swiperRef.current) return;
    if (rest.slidesPerView === 'auto' && rest.centeredSlides && rest.centeredSlidesBounds && scrollCenter) {
      activeIndex !== -1 && swiperRef.current.slideTo(activeIndex, 300, true);
    } else {
      activeIndex !== -1 && swiperRef.current.slideTo(activeIndex);
    }
  }, [activeIndex]);

  const handleSwiper = swiper => {
    swiperRef.current = swiper;
    onSwiper?.(swiper);
  };

  return (
    <ReactSwiper onSwiper={handleSwiper} {...rest}>
      {children}
    </ReactSwiper>
  );
}
